//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//控制《报销单详情页面》费用详情显示隐藏
var infoShowHide = '';
import { guid, formatTime } from '@/common/common';
import {
  saveReExpeAcco, selectExpeAcco, selectCostDetail, costTypeSelect, updateExpeAccoStatus, selectFillList,
  FILE_URL, updateReimburse
} from '@/api/rem/cost/cost';
import { BASIC, DORM } from "@/config/constant";
import promise from '@/axios/promise';
import { Toast } from 'mint-ui';
export default {
  data() {
    return {
      // 按钮loading
      butLoading: false,
      apprNumb: this.$route.query.businessKey,
      taskType: this.$route.query.taskType,
      data: {
        costType: '',
        creaTime: '',
        invoNumb: '',
        date: undefined,
        reimRemark: '',
        fid: '',
        taskType: '',
        reimCostNumb: 0,
        projName: '',
        costIcon: '',
        invoStatus: '',
        invoInfo: ''
      },
      dataList: '',
      reimCostList: [],
      //审批参数
      taskParam: this.$route.query,
      trunMessage: '',
      passMessage: '',
      trunDialog: false,
      passDialog: false,
      costTypeList: [],
      costTypefield: [],
      costInfoList: [],
      costfillList: [],
      approve: false,
      file_URL: '',
      solo: true
    }
  },
  filters: {
    numFilter(value) {
      // 截取当前数据到小数点后两位
      let realVal = parseFloat(value).toFixed(2);
      // num.toFixed(2)获取的是字符串
      return realVal
    },
    dateFilter(value) {
      return value.substring(0, value.length - 2)

    }
  },
  created() {
    console.log(this.$route.query)
    this.taskType = this.$route.query.taskType
    var fid = { 'fid': this.$route.query.businessKey }
    selectExpeAcco(fid).then(response => {
      console.log(response);
      this.data = response;
      if (this.data.reimType == '已驳回' && this.taskType == 'undo') {
        var fid = { 'fid': this.$route.query.businessKey }
        selectExpeAcco(fid).then(response => {
          this.$router.push({ path: '/reimApprEdit', query: { reimData: response } })
        })
      }
    })
    if (this.$route.query != undefined) {
      if (this.$route.query.taskType == 'undo') {
        this.approve = true;
      }
    }
    // var _this=this;
    // setTimeout(function(){
    //   if(this.data.reimType=='已驳回'){
    //       var fid={'fid':this.$route.query.businessKey}
    //       selectExpeAcco(fid).then(response =>{
    //         this.$router.push({ path: '/reimApprEdit',query:{reimData:response}})
    //       })
    //     }
    // },100)
    promise({
      url: DORM + "/expense/selectDictionType",
      method: "get",
      async: false,
      params: { type: "fileUrl" }
    }).then(res => {
      console.log(res);
      this.file_URL = res[0].dicCode
    });

  },
  methods: {
    // 日期格式化
    dateFormatter(date, format) {
      return formatTime(date, format);
    },
    //弹窗显示
    trunDownClk() {
      this.trunDialog = true;
    },
    passClk() {
      this.passDialog = true;
    },
    cancelButton() {
      this.trunDialog = false;
      this.passDialog = false;
      this.trunMessage = '';
      this.passMessage = '';
    },
    //驳回提交
    turnDownSubmit() {
      var params = {
        taskId: this.taskParam.taskId,
        status: 'E',
        msg: this.trunMessage,
        vars: { variables: { 'status': 'E' } },
      };
      this.completeTaskByTaskId(params);
      this.trunDialog = false;

    },
    //通过提交
    passSubmit() {
      var params = {
        taskId: this.taskParam.taskId,
        status: 'S',
        msg: this.passMessage,
        vars: { variables: { 'status': 'S' } },
      };
      this.completeTaskByTaskId(params);
      this.passDialog = false;
    },
    //流程审批
    completeTaskByTaskId(params) {
      this.butLoading = true;
      promise({
        url: BASIC + "/task/completeTaskByTaskId?taskId=" + params.taskId + "&status=" + params.status + "&msg=" + params.msg,
        method: "post",
        headers: { "Content-Type": "application/json" },
        data: JSON.stringify(params.vars),
      }).then(response => {
        if (response.code == 500) {
          Toast({
            message: '请求错误！',
            position: 'top',
            duration: 1500,
            className: "error"
          });
          this.butLoading = false;
        } else if (response.code == 0) {
          var data = {};
          if (params.status == 'S') {
            if (this.taskParam.taskDefinitionKey === "financeApprove") {
              //如果为会计审批通过则修改报销单is_cashier为1
              var reimJson = { fid: this.data.fid, isCashier: 1 }
              updateReimburse({ reimInfo: JSON.stringify(reimJson) }).then(response => {
                if (response) {
                  this.butLoading = false;
                  console.log("已修改会计标记！")
                }
              });
            }
            //如果审批通过后是最后一个节点审批 修改合同状态为已完成
            if (this.taskParam.taskDefinitionKey == "finalApprove") {
              this.butLoading = false;
              // 流程结束的修改，移至结束节点监听事件中了
              //data={id:this.apprNumb,status:'已报销',postingStatus:'未过账'}
            }
          } else if (params.status == 'E') {
            data = { id: this.apprNumb, status: '已驳回' }
            updateExpeAccoStatus(data).then(response => {
              this.butLoading = false;
            });
          }
          Toast({
            message: response.msg,
            position: 'top',
            duration: 1500,
            className: "success"
          });
          this.$router.push({ path: "/" });
        }
      });
    },
    bacList() {
      this.$router.push({ path: '/' })
    },
    //查看费用详情
    seeCostDetail(costType, event, infoFid) {
      console.log(infoFid)
      console.log('详情')
      event.stopImmediatePropagation();
      // console.log(event.currentTarget)
      // console.log(event.target)
      // console.log($(event.currentTarget).find(".extendInfo"))
      var extendInfoTarget = event.currentTarget;
      console.log(infoFid)
      if (infoShowHide == infoFid) {

        infoShowHide = ''
        this.costInfoList = [];
        this.costInfofield = [];
        this.costfillList = [];
        $(event.currentTarget).css('background', 'white')

      } else {
        $('.LookCostDetail').css('background', 'white')
        $(event.currentTarget).css('background', '#F3F4F5')
        $('.extendInfoParents').css('height', '0px');
        $(event.currentTarget).next('.extendInfoParents').css('height', 'auto')

        var thiss = this
        setTimeout(function () {
          infoShowHide = infoFid;
          var fid = { 'Fid': infoFid }
          selectCostDetail(fid).then(response => {
            thiss.costDetail = response
            console.log(thiss.costDetail)
            thiss.invoStatus = thiss.costDetail.invoStatus;
            thiss.invoInfo = thiss.costDetail.invoInfo;
            thiss.costSelectLoad1(costType, extendInfoTarget)
          })
          var fillMainId = { 'mainId': infoFid }
          selectFillList(fillMainId).then(res => {
            thiss.costfillList = res;
            console.log(thiss.costfillList)
          })
        }, 500)
      }

    },
    //点击查看费用
    costSelectLoad1(costType, extendInfoTarget) {
      var info = { 'Fid': costType };
      console.log(costType);
      costTypeSelect(info).then(response => {
        //sample 文本框
        //single 单选框
        //Number 数字名称
        //provincesCities 省市框
        //Multiline 多行文本框
        //multiSelect 多选文本
        //times 日期框
        //dormitory 宿舍框
        this.costInfofield = [];
        this.costInfoList = response.costTypeMinor;
        for (var i = 0; i < response.costTypeMinor.length; i++) {
          if (response.costTypeMinor[i].fielType == "single" || response.costTypeMinor[i].fielType == "multiSelect") {
            if (response.costTypeMinor[i].fielType == "multiSelect") {
              var prinConc1 = response.costTypeMinor[i].prinConc;
              var prinConctoLowerCase1 = prinConc1.toLowerCase()
              var prinConcSplict1 = prinConctoLowerCase1.split('_')
              for (var k = 1; k < prinConcSplict1.length; k++) {
                prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
              }
              var prinConcData = this.costDetail[prinConcSplict1.join('')];
              console.log(prinConcData);
              var extend = response.costTypeMinor[i].extend;
              if (prinConcData != null) {
                var field = { field: response.costTypeMinor[i].prinConc, 'value': prinConcData.split(','), 'extend': extend.split(';') };
                this.costInfofield.push(field)
              } else {
                var field = { field: response.costTypeMinor[i].prinConc, 'value': '', 'extend': extend.split(';') };
                this.costInfofield.push(field)
              }

            } else {
              var prinConc1 = response.costTypeMinor[i].prinConc;
              var prinConctoLowerCase1 = prinConc1.toLowerCase()
              var prinConcSplict1 = prinConctoLowerCase1.split('_')
              for (var k = 1; k < prinConcSplict1.length; k++) {
                prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
              }
              var prinConcData = this.costDetail[prinConcSplict1.join('')];
              console.log(prinConcData);
              var extend = response.costTypeMinor[i].extend;
              var field = { field: response.costTypeMinor[i].prinConc, 'value': prinConcData, 'extend': extend.split(';') };
              this.costInfofield.push(field)
            }

          } else if (response.costTypeMinor[i].fielType == "dataDiction") {
            var extend1 = response.costTypeMinor[i].extend;
            var info = { 'type': extend1 }
            var index = i;
            var _this = this;
            var arr = [];
            promise({
              url: DORM + "/expense/selectDictionType",
              method: "get",
              async: false,
              params: { type: extend1 }
            }).then(res => {
              console.log(res);
              if (res.length != 0) {
                for (var K = 0; K < res.length; K++) {
                  var file = res[K].dicName;
                  arr.push(file)
                }

              }
            });
            var prinConc1 = response.costTypeMinor[i].prinConc;
            var prinConctoLowerCase1 = prinConc1.toLowerCase()
            var prinConcSplict1 = prinConctoLowerCase1.split('_')
            for (var k = 1; k < prinConcSplict1.length; k++) {
              prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
            }
            var prinConcData = this.costDetail[prinConcSplict1.join('')];
            var field = { field: response.costTypeMinor[index].prinConc, 'value': prinConcData, 'extend': arr };
            _this.costInfofield.push(field)
          } else {
            var prinConc1 = response.costTypeMinor[i].prinConc;
            var prinConctoLowerCase1 = prinConc1.toLowerCase()
            var prinConcSplict1 = prinConctoLowerCase1.split('_')
            for (var k = 1; k < prinConcSplict1.length; k++) {
              prinConcSplict1[k] = prinConcSplict1[k].substring(0, 1).toUpperCase() + prinConcSplict1[k].substring(1);
            }
            var prinConcData = this.costDetail[prinConcSplict1.join('')];
            var field = { field: response.costTypeMinor[i].prinConc, 'value': prinConcData, 'extend': [] };
            this.costInfofield.push(field)
          }

        }
      });

    },
    //驳回报销单
    backReim() {
      var data = {};
      data.costType = this.data.costType;
      data.creaTime = this.data.creaTime;
      data.invoNumb = this.data.invoNumb;
      data.reimRemark = this.data.textarea;
      data.costInFo = this.reimCostList;
      data.fid = this.data.fid;
      data.submitType = 'save'
      var reimData = { reimburse: JSON.stringify(data) }
      console.log(reimData);
      // saveReExpeAcco(reimData).then(respones=>{
      //   console.log(respones)
      // })

    },
    //报销单通过
    submitReim() {
      var data = {};
      data.costType = this.data.costType;
      data.creaTime = this.data.creaTime;
      data.invoNumb = this.data.invoNumb;
      data.reimRemark = this.data.textarea;
      data.costInFo = this.reimCostList;
      data.fid = this.data.fid;
      data.submitType = 'submit'
      var reimData = { reimburse: JSON.stringify(data) }
      console.log(reimData);
      // saveReExpeAcco(reimData).then(respones=>{
      //   console.log(respones)
      // })
    },
    //报销单修改
    updateReim() {
      var fid = { 'fid': this.$route.query.businessKey }
      selectExpeAcco(fid).then(response => {
        this.$router.push({ path: '/reimDetail', query: { reimData: response } })
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/reimAppr.vue